import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { safeGet, safeSet, getSafeSession } from '../utils/browserSafe';
import baseURL from '../url';

function getVisitSession() {
    const key = 'ky13_visit_session';
    let value = safeGet(key, '');
    if (!value) {
        value = 'visit_' + Math.random().toString(36).slice(2) + Date.now();
        safeSet(key, value);
    }
    return value;
}

export default function VisitTracker() {
    const location = useLocation();

    useEffect(() => {
        const payload = {
            sessionKey: getVisitSession(),
            path: location.pathname + location.search,
            referer: document.referrer || ''
        };

        fetch(`${baseURL}/visitaPost.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload)
        }).catch(() => {});
    }, [location.pathname, location.search]);

    return null;
}
